import { graphql } from '../../../graphql/generated';

export const SET_DOCTOR_AIS_LINKS_MUTATION = graphql(`
  mutation SetDoctorAisLinks($doctorId: ID!, $links: [DoctorAisLinkInput!]!) {
    setDoctorAisLinks(doctorId: $doctorId, links: $links) {
      id
      vendor
      externalId
    }
  }
`);

export const AIS_LINK_VENDORS_QUERY = graphql(`
  query AisLinkVendors {
    aisLinkVendors {
      key
      displayName
    }
  }
`);
